import React from 'react';
import { SvgIconProps } from '@mui/material';
import { ArrowRight } from './arrow-right';

export const ArrowLeft = (props: SvgIconProps) => (
  <ArrowRight
    {...props}
    sx={{ transform: 'rotate(-180deg)', ...(props.sx || {}) }}
  />
);
